export default __webpack_public_path__ + "static/media/modal-success-icon.86de68f4.svg";